<template>
  <MultipleSelect
    data-private
    hideDetails
    itemValue="id"
    :label="$t('common.tag_other')"
    :options="tagsOptions"
    :value="value"
    :search-input.sync="searchTerm"
    @change="handleChange"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixins/mixin.vue'

import MultipleSelect from '@/components/Core/MultipleSelect.vue'

export default {
  name: 'ExploreTagsSelector',

  mixins: [mixin],

  components: { MultipleSelect },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchTerm: '',
    }
  },

  computed: {
    ...mapGetters(['organizationId', 'organizationTags']),

    tagsOptions() {
      return (
        this.organizationTags?.filter?.(tag => tag?.isEnabled ?? true) ?? []
      )
    },
  },

  methods: {
    handleChange(tags) {
      this.searchTerm = ''
      this.$emit('change', tags)
    },
  },
}
</script>
